import moment from "moment";
import {
    GET_JOURNAL_VOUCHER_REQUEST,
    GET_JOURNAL_VOUCHER_SUCCESS,
    GET_JOURNAL_VOUCHER_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config";

export const getJLVoucherReport = (token, values) => (dispatch) => {

    dispatch({ type: GET_JOURNAL_VOUCHER_REQUEST });
    const newData = {
        from_date: moment(values.from_date).format("MM-DD-YYYY"),
        to_date: moment(values.to_date).format("MM-DD-YYYY"),
        voucher_header_no: values.voucher === undefined ? null : values.voucher,
        gender_id: values.gender === "All" ? null : values.gender,
    };
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/GLVoucherReportAr`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: newData,
    })
        .then((response) => {
            return dispatch({
                type: GET_JOURNAL_VOUCHER_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: GET_JOURNAL_VOUCHER_ERROR,
                payload: [],
            });
        });
};